export const discharge = (num) =>
  num?.toString()?.replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1 ');
